import { colors } from '@paddle/ant-component-library'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const RouterLink = styled(Link)`
  font-size: 14px;
  line-height: 20px;
  color: ${colors.elecBlue[500]};
`
